import React from "react";
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  IconButton,
} from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { styled } from "@mui/material/styles";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import Lottie from "lottie-react";

import Paper from "../icons/paper.json";
import Chain from "../icons/chain.json";
import NicheResearchIcon from "../icons/animation.json";
import aiIcon from "../icons/ai-assistant.gif";
import Cloud from "../icons/cloud-service.gif";
import Cyber from "../icons/cyber-security.gif";
import { useNavigate } from "react-router-dom";
// import { useInView } from "react-intersection-observer";

// import World from "../icons/world.json";
// import Warning from "../icons/warning.json";

const ServiceCard = styled(Card)(({ theme }) => ({
  position: "relative",
  borderWidth: "10px",
  borderStyle: "solid",
  borderColor: "#E5E7EB",
  borderRadius: 20,
  height: "300px",
  boxShadow: "none",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  backgroundColor: "#fff",
  transition: "all 0.3s ease",
  zIndex: 1,

  "&:hover": {
    borderColor: "transparent",
    backgroundImage:
      "linear-gradient(white, white), linear-gradient(to right, rgba(255, 217, 0, 0.19), rgba(255, 192, 203, 0.8), rgba(173, 216, 230, 0.8))",
    backgroundOrigin: "border-box",
    backgroundClip: "padding-box, border-box",
    boxShadow: "0 6px 12px rgba(0, 0, 0, 0.08)",
  },

  "&:hover .rotate-icon": {
    transform: "rotate(40deg)",
    background:
      "linear-gradient(to right, rgba(255, 215, 0, 0.3), rgba(255, 192, 203, 0.3), rgba(173, 216, 230, 0.3))",
    borderRadius: "50%",
    padding: "4px",
    color: "black",
  },
}));

const services = [
  {
    title: "Application Services",
    description:
      "CENSOFT has enormous experience in development of high quality applications for customers across various domains. We offer scalable, secure and robust end to end application development services...",
    icon: Paper,
    link: "/service#service-1",
  },
  {
    title: "Managed Services",
    description:
      "As corporate IT budgets shift towards transformation projects, there is often reduced funding for legacy application and infrastructure maintenance....",
    icon: NicheResearchIcon,
    link: "/service#service-2",
  },
  {
    title: "AI & Data Science",
    description:
      "We help enterprises harness the power of AI and data-driven insights to optimize decision-making, automate workflows, and uncover new opportunities.",
    icon: aiIcon, // Replace with your actual AI icon component
    link: "/service#service-3",
  },
  {
    title: "Business Consulting",
    description:
      "At CENSOFT, our Business Value Model emphasizes Value Identification. We build long-term partnerships, working alongside you rather than just for you...",
    icon: Chain,
    link: "/service#service-4",
  },
  {
    title: "Cloud Solutions",
    description:
      "End-to-end cloud migration, deployment, and optimization services. We design secure, scalable cloud architectures tailored to your business requirements.",
    icon: Cloud, // Replace with your actual SEO icon
    link: "/service#service-5",
  },
  {
    title: "Cybersecurity Solutions",
    description:
      "Comprehensive security services including risk assessment, threat detection, and compliance management. We protect your critical assets with enterprise-grade security frameworks.",
    icon: Cyber, // Replace with your actual digital marketing icon
    link: "/service#service-6",
  },

  // {
  //   title: "Enterprise SEO",
  //   description:
  //     "Enterprise SEO optimizes large websites to improve visibility and drive traffic.",
  //   icon: Rocket,
  // },
  // {
  //   title: "SEO audit",
  //   description:
  //     "An SEO audit evaluates a website identify improvements for better search rankings.",
  //   icon: World,
  // },
  // {
  //   title: "Penalty recovery",
  //   description:
  //     "Penalty recovery fixes issues that caused search engine penalty to restore rankings.",
  //   icon: Warning,
  // },
];

export default function SeoServicesSection() {
  const navigate = useNavigate()
  const handleServiceClick = (id) => {
    navigate("/service#service-0");
  };
  const handleSingleServiceClick = (link) => {
    navigate(link);
  };
  return (
    <Box sx={{ px: { xs: 3, md: 6 }, py: 10, maxWidth: 1350, mx: "auto" }}>
      {/* Container: left + right */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: 4,
        }}
      >
        {/* Left side */}
        <Box
          sx={{
            flex: 1,
            position: "sticky",
            top: 150,
            alignSelf: "start",
            fontFamily: "Aeonik-bold",
          }}
        >
          <Typography
            variant="caption"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              backgroundColor: "#fff",
              px: 2,
              py: 0.5,
              borderRadius: 10,
              border: "0.5px solid gray",
              fontWeight: 600,
              gap: 0.5,
            }}
          >
            <LibraryBooksIcon sx={{ fontSize: 16, color: "blue" }} />
            Feature-services
          </Typography>

          <Typography
            variant="h4"
            fontWeight="bold"
            sx={{
              mt: 2,
              fontFamily: "Aeonik-bold",
              fontSize: { xs: "1.5rem", md: "2.5rem" },
              fontWeight: 1000,
            }}
          >
            Our Services Section
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mt: 2, pb: 3 }}>
            Boost visibility, automate with AI, and build faster with our expert
            digital services.
          </Typography>

          <Button
            onClick={() => handleServiceClick(1)}
            sx={{
              position: "relative",
              overflow: "hidden",
              backgroundColor: "#032262",
              color: "white",
              px: { xs: 4, md: 4 },
              py: { xs: 1.5, md: 1 },
              fontSize: { xs: "0.85rem", md: "1.2rem" },
              fontFamily: "Aeonik-bold, sans-serif",
              textTransform: "none",
              zIndex: 1,
              mt: 3,
              "&:before": {
                content: "''",
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "#a10304",
                transform: "translateY(100%)",
                transition: "transform 0.3s ease-in-out",
                zIndex: -1,
              },
              "&:hover:before": {
                transform: "translateY(0)",
              },
              "&:hover": {
                color: "white",
              },
            }}
          >
            View more services
          </Button>
        </Box>

        {/* Right side */}
        <Box
          sx={{
            flex: 2,
            position: "relative",
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "row",
            gap: 6,
            justifyContent: { xs: "center", md: "flex-start" }, // ✅ Center on mobile
            overflowX: { xs: "auto", md: "visible" }, // ✅ Enable scrolling only on mobile
            maxWidth: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 3,
              justifyContent: "space-between",
            }}
          >
            {services.map((service, i) => (
              <Box
                key={i}
                sx={{
                  width: {
                    xs: "100%", // One box per row on mobile
                    sm: "48%", // Two per row on tablets and up
                  },
                  mb: 4,
                }}
                onClick={() => {
                  if (service.link) {
                    handleSingleServiceClick(service.link);
                  }
                }}
              >
                <ServiceCard>
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                      }}
                    >
                      <Typography variant="h6" fontWeight="bold">
                        {service.title}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mt: 1, flexGrow: 1 }}
                      >
                        {service.description}
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mt: 2,
                        }}
                      >
                        {typeof service.icon === "object" ? (
                          <Lottie
                            animationData={service.icon}
                            loop
                            style={{ width: 100, height: 60 }}
                          />
                        ) : typeof service.icon === "string" &&
                          service.icon.endsWith(".gif") ? (
                          <Box
                            component="img"
                            src={service.icon}
                            alt={`${service.title} icon`}
                            sx={{
                              width: 100,
                              height: 60,
                              objectFit: "contain",
                            }}
                          />
                        ) : (
                          <Typography fontSize={40}>
                            {service.icon || "🧩"}
                          </Typography>
                        )}
                        <IconButton
                          className="rotate-icon"
                          sx={{
                            backgroundColor: "#fff",
                            borderRadius: "50%",
                            border: "1px solid #E5E7EB",
                            transition: "background 0.3s",
                            "&:hover": {
                              background:
                                "linear-gradient(to right, gold, pink, lightblue, gold)",
                            },
                          }}
                        >
                          <ArrowOutwardIcon
                            sx={{
                              fontSize: 20,
                              transition: "transform 0.3s ease",
                            }}
                          />
                        </IconButton>
                      </Box>
                    </Box>
                  </CardContent>
                </ServiceCard>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
